import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { Text } from "@dhxete/text";
import { useAppContext } from "../../Context";

const Case = ({
  className,
  id
}) => {
  const {
    state: {
      langStrings
    },
    dispatch,
    handleCaseAnalytics
  } = useAppContext();
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    onClick: () => {
      dispatch({
        type: "GO_TO_CREATE_CASE_PAGE"
      });
      handleCaseAnalytics();
    },
    id: id
  }, /*#__PURE__*/React.createElement(Text, {
    fontWeight: "bold"
  }, langStrings.contactOptions.createCase), /*#__PURE__*/React.createElement(Text, null, langStrings.contactOptions.getCaseAnswer2Days));
};

Case.propTypes = {
  className: PropTypes.string,
  isCase: PropTypes.bool,
  id: PropTypes.string
};
export default styled(Case)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: column;
  width: calc(100% - 50px);
  height: 80px;
  background: #f7fcfe;
  border: 1px #0695d7 solid;
  cursor: pointer;
`;